import {
  autoserialize,
  autoserializeAs
} from 'cerialize';

import { Attachment } from './attachment';

export class CommentChange {
  @autoserialize field!: string;
  @autoserialize old?: unknown;
  @autoserialize new?: unknown;
}

export class CommentMetadata {
  @autoserialize event?: string;
  @autoserialize changes?: Array<CommentChange>;
}

export class Comment {
  @autoserialize id!: string;
  @autoserialize text!: string;
  @autoserialize author!: string;

  @autoserializeAs('target_name') targetName!: string;
  @autoserializeAs('target_type') targetType!: string;
  @autoserializeAs('target_id') targetId!: string;
  @autoserializeAs('comment_type') commentType!: number;
  @autoserializeAs('date_created') dateCreated!: string;

  @autoserializeAs('tracker_type') trackerType!: number;
  @autoserializeAs(Attachment) attachments?: Array<Attachment>;
  @autoserialize metadata?: CommentMetadata;
}
